import { GetterTree } from 'vuex';
import { BoardsClassroomModel, ClassroomModel } from '@descomplica/dex-models';
import { BoardsClassroomState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<BoardsClassroomState, RootState> = {
  boardsClassroomById: (state, boardsClassroomsGetters) => (boardsClassroomId: number) => {
    const boardsClassroom = state.boardsClassrooms[boardsClassroomId.toString()];
    return boardsClassroom
      ? new BoardsClassroomModel(boardsClassroom, boardsClassroomsGetters)
      : undefined;
  },
  // OP method to solve many to many two way relation
  classroomsByBoardId: (state, boardsClassroomsGetters) => (boardId: number) => {
    return Object.values(state.boardsClassrooms).reduce(
      (acc: ClassroomModel[], boardsClassroom) => {
        if (boardsClassroom.boardByBoardId === boardId)
          acc.push(boardsClassroomsGetters.classroomById(boardsClassroom.classroomId));
        return acc;
      },
      [],
    );
  },
};

export default getters;
